import s from './profile-card.module.scss'
import { Button } from '@shared/ui/button/button'
import { getAge } from '@utils/lib/age'
import { getNoun } from '@utils/lib/getNoun'
import { getAvatarUrl } from '@utils/lib/getAvatarUrl'

const avatarUrl = getAvatarUrl

export const ProfileCard = ({ profile, onEdit }) => {
	const age = getAge(profile.bday)

	return (
		<div className={s.card}>
			<div className={s.avatar}>
				<img src={avatarUrl(profile.avatar)} alt="" />
			</div>
			<div className={s.cardContent}>
				<span className={s.name}>{profile.name}</span>
				<span className={s.meta}>
					{age !== null ? `${age} ${getNoun(age, 'год', 'года', 'лет')}` : 'Возраст не указан'}
					{profile.instruments?.length ? ` · ${profile.instruments.map((i) => i.name).join(', ')}` : ''}
				</span>
			</div>
			<Button label="Изменить" size="small" theme="secondary" className={s.editBtn} onClick={() => onEdit(profile)} />
		</div>
	)
}
